import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import * as FileSaver from 'file-saver';

import { DashboardService } from '../dashboard.service';
import { PedidoDetalheDashboard } from '../models/dashboard';


@Component({
  selector: 'app-dashboard-evento-vendas-detalhe',
  templateUrl: './dashboard-evento-vendas-detalhe.component.html',
  styleUrls: ['./dashboard-evento-vendas-detalhe.component.scss']
})
export class DashboardEventoVendasDetalheComponent implements OnInit {


  public pedidos: PedidoDetalheDashboard[];
  public idEvento: string = "1";

  constructor(public dashboardService: DashboardService,
    private router: Router,
    private _Activatedroute: ActivatedRoute) { }

  ngOnInit(): void {

    this._Activatedroute.paramMap.subscribe(params => {
      if (params.has('idEvento')) {
        this.idEvento = params.get('idEvento');
        this.getPedidos();
      }
    });
  }

  getPedidos() {
    this.dashboardService.getListaPedidoDetalhe(this.idEvento).subscribe(
      (res) => {
        if (res) {
          this.pedidos = res;
        }
      },
      err => {
        console.log("DashboardVendasDetalhe - Pedidos");
        console.log(err);
      }
    );
  }

  

exportExcel() {

console.log("excel");

     import("xlsx").then(xlsx => {
         const worksheet = xlsx.utils.json_to_sheet(this.pedidos);
         const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
         const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
         this.saveAsExcelFile(excelBuffer, "pedidos");
     });
}

 saveAsExcelFile(buffer: any, fileName: string): void {
     let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
     let EXCEL_EXTENSION = '.xlsx';
     const data: Blob = new Blob([buffer], {
         type: EXCEL_TYPE
     });
     FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
 }

}
